import { render, staticRenderFns } from "./sub-require-info.vue?vue&type=template&id=2b05cfae&scoped=true&"
import script from "./sub-require-info.vue?vue&type=script&lang=js&"
export * from "./sub-require-info.vue?vue&type=script&lang=js&"
import style0 from "./sub-require-info.vue?vue&type=style&index=0&id=2b05cfae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b05cfae",
  null
  
)

export default component.exports